// extracted by mini-css-extract-plugin
module.exports = {"buttons":"footer-module--buttons--1Wui3","logosContainer":"footer-module--logosContainer--3hl4z"};